/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountType } from './AccountType';
import {
    AccountTypeFromJSON,
    AccountTypeFromJSONTyped,
    AccountTypeToJSON,
} from './AccountType';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
} from './Address';
import type { BankAccount } from './BankAccount';
import {
    BankAccountFromJSON,
    BankAccountFromJSONTyped,
    BankAccountToJSON,
} from './BankAccount';
import type { Organisation } from './Organisation';
import {
    OrganisationFromJSON,
    OrganisationFromJSONTyped,
    OrganisationToJSON,
} from './Organisation';
import type { PaymentType } from './PaymentType';
import {
    PaymentTypeFromJSON,
    PaymentTypeFromJSONTyped,
    PaymentTypeToJSON,
} from './PaymentType';
import type { Role } from './Role';
import {
    RoleFromJSON,
    RoleFromJSONTyped,
    RoleToJSON,
} from './Role';
import type { TenancyRole } from './TenancyRole';
import {
    TenancyRoleFromJSON,
    TenancyRoleFromJSONTyped,
    TenancyRoleToJSON,
} from './TenancyRole';

/**
 * 
 * @export
 * @interface Customer
 */
export interface Customer {
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    readonly keycloakId?: string;
    /**
     * login/email
     * @type {string}
     * @memberof Customer
     */
    username?: string;
    /**
     * update only, this will never be exposed
     * @type {string}
     * @memberof Customer
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    reference?: string;
    /**
     * 
     * @type {Array<Role>}
     * @memberof Customer
     */
    readonly roles?: Array<Role>;
    /**
     * 
     * @type {Array<TenancyRole>}
     * @memberof Customer
     */
    readonly tenancyRoles?: Array<TenancyRole>;
    /**
     * 
     * @type {Organisation}
     * @memberof Customer
     */
    organisation?: Organisation;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    salutation?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    sapNumber?: string;
    /**
     * 
     * @type {Address}
     * @memberof Customer
     */
    address?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Customer
     */
    invoiceAddress?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Customer
     */
    shippingAddress?: Address;
    /**
     * 
     * @type {BankAccount}
     * @memberof Customer
     */
    bankAccount?: BankAccount;
    /**
     * 
     * @type {PaymentType}
     * @memberof Customer
     */
    paymentType?: PaymentType;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    contact?: string;
    /**
     * Website des Kunden. Wird auf oeffentlichen Seiten des
     * datenbankgestalters (z. B. der Bestaetigungsseite nach dem
     * Double-Opt-In) als Knopf „Zur Website" angeboten, damit der
     * Besucher zum Anbieter zurueckfindet statt bei uns zu stranden.
     * Ohne Eintrag erscheint kein Knopf.
     * @type {string}
     * @memberof Customer
     */
    companyWebsite?: string;
    /**
     * Datenschutz-Kontakt des Betriebs -- Name, Anschrift oder
     * E-Mail-Adresse der Stelle, an die sich Betroffene wenden koennen.
     * 
     * WOFUER: Datenschutzhinweise muessen eine solche Stelle nennen. Der
     * Betrieb traegt sie EINMAL im Profil ein; die Hinweistexte holen sie
     * sich ueber den Platzhalter `{{user.dataProtectionContact}}`.
     * 
     * WARUM NICHT IM TEXT SELBST: Dieselbe Angabe steht sonst in jedem
     * Hinweistext jeder Datenbank erneut -- und aendert sich der Kontakt,
     * bleibt sie an den vergessenen Stellen falsch stehen. Falsche
     * Datenschutzangaben sind kein Schoenheitsfehler.
     * @type {string}
     * @memberof Customer
     */
    dataProtectionContact?: string;
    /**
     * Speicherdauer der Daten in Worten, z. B. „drei Jahre nach Ende der
     * Schulung" oder „bis zum Widerruf". Platzhalter
     * `{{user.dataRetentionPeriod}}`.
     * 
     * BEWUSST FREITEXT, keine Zahl: Die Dauer haengt am Zweck und laesst
     * sich selten in Tagen ausdruecken. Eine Zahl zwaenge den Betrieb zu
     * einer Genauigkeit, die er nicht hat -- und der Hinweistext soll
     * lesbar bleiben, nicht rechnen.
     * @type {string}
     * @memberof Customer
     */
    dataRetentionPeriod?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    companyBranch?: string;
    /**
     * 
     * @type {string}
     * @memberof Customer
     */
    functionInCompany?: string;
    /**
     * 
     * @type {number}
     * @memberof Customer
     */
    numberOfEmployees?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    newsletter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    freeOfCharge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    readOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    eligibleForPurchase?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    readonly created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    deactivationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    deletionNotificationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    deletionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    readonly updated?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Customer
     */
    readonly passwordUpdated?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof Customer
     */
    readonly anonymous?: boolean;
    /**
     * 
     * @type {AccountType}
     * @memberof Customer
     */
    accountType?: AccountType;
}

/**
 * Check if a given object implements the Customer interface.
 */
export function instanceOfCustomer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CustomerFromJSON(json: any): Customer {
    return CustomerFromJSONTyped(json, false);
}

export function CustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Customer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'keycloakId': !exists(json, 'keycloakId') ? undefined : json['keycloakId'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'reference': !exists(json, 'reference') ? undefined : json['reference'],
        'roles': !exists(json, 'roles') ? undefined : ((json['roles'] as Array<any>).map(RoleFromJSON)),
        'tenancyRoles': !exists(json, 'tenancyRoles') ? undefined : ((json['tenancyRoles'] as Array<any>).map(TenancyRoleFromJSON)),
        'organisation': !exists(json, 'organisation') ? undefined : OrganisationFromJSON(json['organisation']),
        'company': !exists(json, 'company') ? undefined : json['company'],
        'salutation': !exists(json, 'salutation') ? undefined : json['salutation'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'sapNumber': !exists(json, 'sapNumber') ? undefined : json['sapNumber'],
        'address': !exists(json, 'address') ? undefined : AddressFromJSON(json['address']),
        'invoiceAddress': !exists(json, 'invoiceAddress') ? undefined : AddressFromJSON(json['invoiceAddress']),
        'shippingAddress': !exists(json, 'shippingAddress') ? undefined : AddressFromJSON(json['shippingAddress']),
        'bankAccount': !exists(json, 'bankAccount') ? undefined : BankAccountFromJSON(json['bankAccount']),
        'paymentType': !exists(json, 'paymentType') ? undefined : PaymentTypeFromJSON(json['paymentType']),
        'contact': !exists(json, 'contact') ? undefined : json['contact'],
        'companyWebsite': !exists(json, 'companyWebsite') ? undefined : json['companyWebsite'],
        'dataProtectionContact': !exists(json, 'dataProtectionContact') ? undefined : json['dataProtectionContact'],
        'dataRetentionPeriod': !exists(json, 'dataRetentionPeriod') ? undefined : json['dataRetentionPeriod'],
        'companyBranch': !exists(json, 'companyBranch') ? undefined : json['companyBranch'],
        'functionInCompany': !exists(json, 'functionInCompany') ? undefined : json['functionInCompany'],
        'numberOfEmployees': !exists(json, 'numberOfEmployees') ? undefined : json['numberOfEmployees'],
        'newsletter': !exists(json, 'newsletter') ? undefined : json['newsletter'],
        'verified': !exists(json, 'verified') ? undefined : json['verified'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'freeOfCharge': !exists(json, 'freeOfCharge') ? undefined : json['freeOfCharge'],
        'readOnly': !exists(json, 'readOnly') ? undefined : json['readOnly'],
        'eligibleForPurchase': !exists(json, 'eligibleForPurchase') ? undefined : json['eligibleForPurchase'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'deactivationDate': !exists(json, 'deactivationDate') ? undefined : (new Date(json['deactivationDate'])),
        'deletionNotificationDate': !exists(json, 'deletionNotificationDate') ? undefined : (new Date(json['deletionNotificationDate'])),
        'deletionDate': !exists(json, 'deletionDate') ? undefined : (new Date(json['deletionDate'])),
        'updated': !exists(json, 'updated') ? undefined : (new Date(json['updated'])),
        'passwordUpdated': !exists(json, 'passwordUpdated') ? undefined : (new Date(json['passwordUpdated'])),
        'anonymous': !exists(json, 'anonymous') ? undefined : json['anonymous'],
        'accountType': !exists(json, 'accountType') ? undefined : AccountTypeFromJSON(json['accountType']),
    };
}

export function CustomerToJSON(value?: Customer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
        'reference': value.reference,
        'organisation': OrganisationToJSON(value.organisation),
        'company': value.company,
        'salutation': value.salutation,
        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phone': value.phone,
        'sapNumber': value.sapNumber,
        'address': AddressToJSON(value.address),
        'invoiceAddress': AddressToJSON(value.invoiceAddress),
        'shippingAddress': AddressToJSON(value.shippingAddress),
        'bankAccount': BankAccountToJSON(value.bankAccount),
        'paymentType': PaymentTypeToJSON(value.paymentType),
        'contact': value.contact,
        'companyWebsite': value.companyWebsite,
        'dataProtectionContact': value.dataProtectionContact,
        'dataRetentionPeriod': value.dataRetentionPeriod,
        'companyBranch': value.companyBranch,
        'functionInCompany': value.functionInCompany,
        'numberOfEmployees': value.numberOfEmployees,
        'newsletter': value.newsletter,
        'verified': value.verified,
        'enabled': value.enabled,
        'freeOfCharge': value.freeOfCharge,
        'readOnly': value.readOnly,
        'eligibleForPurchase': value.eligibleForPurchase,
        'deactivationDate': value.deactivationDate === undefined ? undefined : (value.deactivationDate.toISOString()),
        'deletionNotificationDate': value.deletionNotificationDate === undefined ? undefined : (value.deletionNotificationDate.toISOString()),
        'deletionDate': value.deletionDate === undefined ? undefined : (value.deletionDate.toISOString()),
        'accountType': AccountTypeToJSON(value.accountType),
    };
}

